"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ActionDetails_vue_1 = __importDefault(require("./ActionDetails.vue"));
const ActionLocTim_vue_1 = __importDefault(require("./ActionLocTim.vue"));
const ActionVisibility_vue_1 = __importDefault(require("./ActionVisibility.vue"));
const ActionCsv_vue_1 = __importDefault(require("./ActionCsv.vue"));
let BannerActions = class BannerActions extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mode = 'details';
        this.isReduceResultPanel = false;
    }
    changeMode(newMode) {
        this.mode = newMode;
        if (this.isReduceResultPanel) {
            this.isReduceResultPanel = !this.isReduceResultPanel;
        }
    }
    reducePanel() {
        this.isReduceResultPanel = !this.isReduceResultPanel;
        if (!this.isReduceResultPanel) {
            this.mode = 'details';
        }
        else {
            this.mode = '';
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BannerActions.prototype, "project", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BannerActions.prototype, "summaryData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BannerActions.prototype, "summaryConfigData", void 0);
BannerActions = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            List: lucide_vue_next_1.List,
            MapPin: lucide_vue_next_1.MapPin,
            ListIcon: bmk_ui_framework_1.ListIcon,
            Eye: lucide_vue_next_1.Eye,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ArrowLeft: lucide_vue_next_1.ArrowLeft,
            ActionDetails: ActionDetails_vue_1.default,
            ActionLocTim: ActionLocTim_vue_1.default,
            ActionVisibility: ActionVisibility_vue_1.default,
            FileSpreadsheet: lucide_vue_next_1.FileSpreadsheet,
            ActionCsv: ActionCsv_vue_1.default
        },
    })
], BannerActions);
exports.default = BannerActions;
